import { useMotionValueEvent, useScroll } from "motion/react";
import { useState } from "react";

/** True when vertical scroll position is strictly greater than `threshold` (px). */
export function useScrolledPast(threshold: number) {
  const { scrollY } = useScroll();
  const [past, setPast] = useState(false);

  useMotionValueEvent(scrollY, "change", (latest) => {
    setPast(latest > threshold);
  });

  return past;
}
